import styled from 'styled-components';

export const StickySection = styled.section`
  position: static;
  height: auto;
  @media (min-width: 720px) {
    height: calc(100vh);
    position: sticky;
    top: 134px;
    order: ${(props) => props.showOrder};
  }
`;

export const AskQuestionLogo = styled.img`
  width: 100%;
  max-width: 70px;
  height: auto;
`;

export const BlackButton = styled.button`
  font-family: 'Montserrat';
  outline: none;
  background: #fff;
  border: 1px solid hsl(0deg, 0%, 0%, 87%);
  border-radius: 2px;
  color: hsl(0deg, 0%, 0%, 87%);
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  height: 38px;
  margin-top: 16px;
  line-height: 38px;
  max-width: 120px;
  width: 100%;
  cursor: pointer;

  &:hover {
    background: #ef4e5e;
    color: #fff;
    border: 1px solid #ef4e5e;
  }

  @media (max-width: 720px) {
    cursor: default;
    max-width: 100%;
  }
`;

export const GetExpertAns = styled.p`
  font-weight: 500;
  color: rgb(0 0 0 / 60%);
  font-size: 11px;
`;

export const AskYourQuestion = styled.p`
  padding: 6px 0;
  color: rgb(0 0 0 / 87%);
  font-size: 16px;
  font-weight: bold;
`;

export const MobileFlex = styled.div`
  @media (max-width: 720px) {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
`;

export const CardSectionAskNow = styled.div`
  padding: 20px 22px 20px;
  border: 1px solid hsl(0deg, 0%, 0%, 10%);
  border-radius: 8px;
  margin-bottom: 30px;
  height: max-content;
  top: 134px;
  background-color: #fff;

  @media (max-width: 720px) {
    display: block;
    top: 0px;
    margin: 10px 10px 16px;
  }

  &.notVisible {
    visibility: hidden;
  }

  &.visible {
    visibility: visible;
  }

  &.transitionClass {
    transition: all 0.2s ease-in-out;
  }

  &.gridcardopacity {
    opacity: 0.5;
  }
`;
